var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',{staticClass:"wbkg-wrapper",attrs:{"id":"wbkg_wrapper"}},[_c('div',{style:(_vm.componentVisibilityStyle)},[(_vm.isMetadataInitialised)?_c('router-view'):_vm._e()],1),_c('toast-handler')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }